































































import { Component, Vue } from 'vue-property-decorator';
import { UserRole } from '@/resource/user/user.model';
import { getRole } from '@/utils/cookie';
import { getAllPreCollections } from '@/utils/pre-collection/pre-collection-util';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import LoadingBox from '@/components/common/LoadingBox.vue';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';
import generatePrecollectionUrl from '@/utils/common/generate-precollection-url';

@Component({
  components: { VueGoodTable, LoadingBox },
})
export default class AdminPreCollections extends Vue {
  get userRole(): UserRole | null {
    return getRole();
  }

  isLoading = true;

  preCollections: PreCollection[] = [];

  columns = [
    {
      label: 'id',
      field: 'id',
      type: 'number',
    },
    {
      label: 'uuid',
      field: 'uuid',
    },
    {
      label: 'name',
      field: 'name',
    },
    {
      label: 'description',
      field: 'description',
    },
    {
      label: 'type',
      field: 'type',
    },
    {
      label: 'form',
      field: 'form',
      type: 'number',
    },
    {
      label: 'year',
      field: 'year',
      type: 'number',
    },
    {
      label: 'subject',
      field: 'subject',
    },
    {
      label: 'created By',
      field: 'createdBy',
    },
    {
      label: 'created At',
      field: 'createdAt',
    },
    {
      label: 'isDraft',
      field: 'isDraft',
    },
    {
      label: 'view',
      field: 'id',
    },
    {
      label: 'edit',
      field: 'id',
    },
  ];

  rows: any[] = [];
  total = 0;

  async created() {
    await this.fetchAllPreCollection();
  }

  async fetchAllPreCollection() {
    this.isLoading = true;
    this.preCollections = await getAllPreCollections();
    this.rows = this.preCollections.map(pre => {
      return {
        id: pre.id,
        uuid: pre.uuid,
        name: pre.name,
        description: pre.description,
        type: pre.type,
        form: pre.form,
        year: pre.year,
        isDraft: pre.isDraft,
        subject: pre.subject.name,
        createdBy: pre.user.firstName,
        createdAt: this.$dayjs(pre.createdAt).format('h:mma, DD/M/YYYY'),
        url: generatePrecollectionUrl(pre),
      };
    });
    this.total = this.preCollections.length;
    this.isLoading = false;
  }

  onSearch(params: any) {
    this.total = params.rowCount;
  }

  searchData(row: any, col: any, cellValue: string, searchTerm: string) {
    const isCustomSearch = searchTerm.search('=');
    const searchTerms = searchTerm.split(',');

    if (isCustomSearch !== -1 && col.field === 'customSearch') {
      let count = 0;

      for (const searchTerm of searchTerms) {
        const i = ((cellValue as unknown) as any[]).indexOf(searchTerm);

        if (i !== -1) {
          count += 1;
        }
      }

      if (count === searchTerms.length) {
        return true;
      } else {
        return false;
      }
    } else if (searchTerm == '') {
      return true;
    } else {
      return `${cellValue}`.search(searchTerm) !== -1;
    }
  }
}
